export const toTitleCase = (s: string): string => {
  return s
    .split(" ")
    .map((w) => {
      return w[0].toUpperCase() + w.substring(1).toLowerCase();
    })
    .join(" ");
};
